import get from 'lodash.get';
import { TYPES } from './actions';

const getNewBannerState = (state, { classId, studentUid }, updatedParams) => ({
    ...state,
    [classId]: {
        ...get(state, classId, {}),
        [studentUid]: {
            ...get(state, `${classId}.${studentUid}`, {}),
            ...updatedParams,
        },
    },
});

export const bannerReducer = (state, { type, payload }) => {
    switch (type) {
        case TYPES.HIDE_PM_RECOMMENDATION_BANNER:
            return getNewBannerState(state, payload, { isPMRecommendationBannerVisible: false });
        case TYPES.HIDE_BM_MAZE_BANNER:
            return getNewBannerState(state, payload, { isBMMazeBannerVisible: false });
        case TYPES.SHOW_BM_MAZE_BANNER:
            return getNewBannerState(state, payload, { isBMMazeBannerVisible: true });
        case TYPES.HIDE_BM_CP_BANNER:
            return getNewBannerState(state, payload, { isBMCPBannerVisible: false });
        case TYPES.SHOW_BM_CP_BANNER:
            return getNewBannerState(state, payload, { isBMCPBannerVisible: true });
        case TYPES.HIDE_BM_INTERVENTION_BANNER:
            return getNewBannerState(state, payload, { isBMInterventionBannerVisible: false });
        case TYPES.HIDE_BM_LNF_PSF_BANNER:
            return getNewBannerState(state, payload, { isBMLNFPSFBannerVisible: false });
        case TYPES.SHOW_BM_LNF_PSF_BANNER:
            return getNewBannerState(state, payload, { isBMLNFPSFBannerVisible: true });
        case TYPES.ENABLE_MAZE_BANNER:
            return getNewBannerState(state, payload, {
                isMazeBannerAvailable: payload.isAvailable,
            });
        case TYPES.ENABLE_CP_BANNER:
            return getNewBannerState(state, payload, {
                isCPBannerAvailable: payload.isAvailable,
            });
        case TYPES.ENABLE_LNFPSF_BANNER:
            return getNewBannerState(state, payload, {
                skillNames: payload.skillNames,
                isLNFPSFBannerAvailable: true,
            });
        case TYPES.HIDE_FNL_BANNER:
            return getNewBannerState(state, payload, { isFNLBannerVisible: false });
        case TYPES.SHOW_FNL_BANNER:
            return getNewBannerState(state, payload, { isFNLBannerVisible: true });
        case TYPES.ENABLE_FNL_BANNER:
            return getNewBannerState(state, payload, {
                skillNames: payload.skillNames,
                isFNLBannerAvailable: true,
            });
        case TYPES.HIDE_SUMMER_BANNER:
            return getNewBannerState(state, payload, { isSummerBannerVisible: false });
        case TYPES.HIDE_PM_CP_BANNER:
            return getNewBannerState(state, payload, { isPMCPBannerVisible: false });
        case TYPES.SHOW_PM_CP_BANNER:
            return getNewBannerState(state, payload, { isPMCPBannerVisible: true });
        case TYPES.ENABLE_PM_CP_BANNER:
            return getNewBannerState(state, payload, {
                isPMCPBannerAvailable: payload.isAvailable,
            });
        case TYPES.SHOW_SUMMER_BANNER:
            return getNewBannerState(state, payload, { isSummerBannerVisible: true });
        default:
            return state;
    }
};

export default bannerReducer;
